import React, { createContext, useState, useEffect } from 'react';
import { setNotify } from '../utils/methods/notification';
import { Alert, Snackbar } from '@mui/material';

const NotificationContext = createContext({});

export const NotificationProvider = ({ children }) => {
  const [currentNotification, setCurrentNotification] = useState(null);

  const handleNotification = (message, options = {}) => {
    const notification = {
      id: Date.now(),
      message,
      severity: options?.severity || 'default',
      duration: options?.duration || 3000,
      position: options?.position || { vertical: 'top', horizontal: 'right' }
    };

    setCurrentNotification(notification);
  };

  useEffect(() => {
    // Register the notification handler globally
    setNotify(handleNotification);
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setCurrentNotification(null);
  };

  return (
    <NotificationContext.Provider value={{}}>
      {children}
      {currentNotification && (
        <Snackbar
          open={!!currentNotification}
          autoHideDuration={currentNotification?.duration}
          onClose={handleClose}
          anchorOrigin={currentNotification?.position}
          disableWindowBlurListener // ✅ stops observer from reacting to blur/focus
          >
          <Alert
            onClose={handleClose}
            severity={currentNotification?.severity}
            variant="filled"
            sx={{ width: "100%", color: "white", fontSize: 16 }}
          >
            {currentNotification?.message}
          </Alert>
        </Snackbar>
      )}
    </NotificationContext.Provider>
  );
};
